import React from 'react';
import { Card } from '../ui/card';

const AUDIT_DOT_COLOR = (action) =>
  action === 'login' ? '#059669' : action === 'user_deleted' ? '#DC2626' : action === 'register' ? '#0076A3' : '#D97706';

const AuditRow = ({ log }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.625rem 0.875rem', borderRadius: 8, background: '#FAF7F2', border: '1px solid #F0EBE3', fontSize: '0.8125rem' }}>
    <div style={{ width: 8, height: 8, borderRadius: '50%', flexShrink: 0, background: AUDIT_DOT_COLOR(log.action) }} />
    <div style={{ flex: 1, minWidth: 0 }}>
      <span style={{ fontWeight: 600, color: '#0076A3' }}>{log.user_name || log.details?.email || 'System'}</span>
      <span style={{ color: '#64748B' }}> — </span>
      <span style={{ color: '#4A5568', textTransform: 'capitalize' }}>{log.action?.replace('_', ' ')}</span>
      {log.details?.email && log.action === 'login' && (
        <span style={{ color: '#94A3B8' }}> ({log.details.email}, {log.details.role})</span>
      )}
      {log.details?.changes && (
        <span style={{ color: '#94A3B8' }}> → {JSON.stringify(log.details.changes)}</span>
      )}
      {log.target_email && (
        <span style={{ color: '#DC2626' }}> [{log.target_email}]</span>
      )}
    </div>
    <span style={{ fontSize: '0.625rem', color: '#94A3B8', whiteSpace: 'nowrap' }}>
      {log.created_at ? new Date(log.created_at).toLocaleString() : ''}
    </span>
  </div>
);

export const AdminAuditTab = ({ auditLogs }) => (
  <Card style={{ background: '#fff', border: '1px solid #ECE7DE', borderRadius: 14, padding: '1.5rem' }}>
    <h3 style={{ fontFamily: 'Cabinet Grotesk', fontSize: '1rem', fontWeight: 600, color: '#0076A3', marginBottom: '1rem' }}>Audit Trail</h3>
    {auditLogs.length === 0 ? (
      <div style={{ textAlign: 'center', padding: '2rem', color: '#94A3B8' }}>No audit events recorded yet. Events will appear here after logins, user changes, and other sensitive operations.</div>
    ) : (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem' }}>
        {auditLogs.map((log, i) => (
          <AuditRow key={`audit-${i}`} log={log} />
        ))}
      </div>
    )}
  </Card>
);
